import { FormattedMessage } from 'react-intl';

import { ICardFooterProps } from './card-footer.models';
import { useStyles } from './card-footer.styles';
import { CompliancePeriodField } from './compliance-period-field';
import { checkComplianceActive } from '../../../../../../../../utils/user/check-compliance-active';

export const CardFooter = ({
  lensesProfileData, isOneDateBrand, lensesData,
}: ICardFooterProps): JSX.Element => {
  const classes = useStyles();
  const { compliancePeriodEndDate } = lensesProfileData;
  const isCompliancePeriod = !!compliancePeriodEndDate && checkComplianceActive(compliancePeriodEndDate);

  return (
    <div
      className={classes.root}
      data-testid="my-lenses-card-footer"
    >
      {(isCompliancePeriod && !isOneDateBrand) ? (
        <CompliancePeriodField
          complianceDate={compliancePeriodEndDate}
          lensesData={lensesData}
        />
      ) : (
        <p
          className={classes.button}
          data-testid="my-lenses-card-footer-button"
        >
          <FormattedMessage
            id="myLensesPreview.fittingLink.label"
          />
        </p>
      )}
    </div>
  );
};
